import React from "react";
import FInputt from "../../../components/FInputt/FInputt";


const CallToAction = ({ title="", subtitle="", button={visible:false, title:"", action:()=>{}}}) => {
  return (
    <div className="bg-[#DCDAD1] p-2 rounded-md mb-5 mt-5">
        <div className="flex flex-row">
            {/* <div className="w-[30%] flex justify-center"><img src={require("../../components/assets/images/pedir.png")} alt="" /></div> */}
            <div className=" w-[100%] p-1">
                <div className="font-bold">{title}</div>
                <div className="text-xs">{subtitle}</div>
                {button.visible ==true ? <div className="mt-2"><FInputt type="botton" title={button.title} onChange={button.action} /></div> : null}
            </div>
        </div>   
    </div>      
  );
};

export default CallToAction;
